export const COMPANY = {
  name: "Lamoni Lab S.r.l.",
  address: "Via Osteria del Finocchio 37, 00132 Roma (RM)",
  mapAddress: "Via Osteria del Finocchio 37, 00132 Roma",
  vat: "11371351005",
  rea: "RM - 1299080",
  email: "info@tytocare.it",
  phone: "+393358330304",
  phoneDisplay: "335 833 0304",
  brand: "TytoCare Italia",
  site: "tytocare.it",
};

export const LEGAL_PAGES = [
  { path: "/privacy-policy", label: "Privacy Policy" },
  { path: "/termini-e-condizioni", label: "Termini e Condizioni" },
  { path: "/cookie-policy", label: "Cookie Policy" },
];
